var React = require('react');

function AlertCircle (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"system/alert-circle"},React.createElement("path",{"id":"Vector","d":"M12 2.24817C6.62391 2.24817 2.25 6.62208 2.25 11.9982C2.25 17.3743 6.62391 21.7482 12 21.7482C17.3761 21.7482 21.75 17.3743 21.75 11.9982C21.75 6.62208 17.3761 2.24817 12 2.24817ZM12.9375 17.244H11.0625V15.369H12.9375V17.244ZM12.75 14.2482H11.25L10.9688 6.74817H13.0313L12.75 14.2482Z","fill":"#CF2029"})));
}

AlertCircle.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = AlertCircle;

AlertCircle.default = AlertCircle;
